
import Vue from "vue";
import HeroBanner from "@/components/common/HeroBanner.vue";
import BreadCrumb from "@/components/common/BreadCrumb.vue";
import store from "@/store";
import UIFeatureMixin from "@/mixins/UIFeatureMixin.vue";
import { IBreadCrumbRoute } from "@/types";
import TransProgramOverviewContent from "@/components/transPrograms/TransProgramOverviewContent.vue";

export default Vue.extend({
  name: "trans-program-overview",
  components: { HeroBanner, BreadCrumb, TransProgramOverviewContent },
  mixins: [UIFeatureMixin],
  data() {
    return {
      description:
        "Pennsylvania offers many transportation services to meet your needs.",
      routes: [
        { to: { name: "home" }, text: "Home" },
        {
          to: { name: "transProgramOverview" },
          text: "Transportation Programs",
        },
      ] as Array<IBreadCrumbRoute>,
    };
  },
  created() {
    store.dispatch.uiFeatureModule.getUIFeatures(
      "TRNS_PGM,MONEY,WHL_CHR,OLD_65"
    );
  },
});
